import { useQuery, useSubscription } from "@apollo/react-hooks";
import { GET_OPEN_APPROVALS_LIST } from "my-time/graphql/queries";
import { MY_TIME_REQUESTS_SUBSCRIPTION } from "my-time/graphql/subscriptions";

export const useMyTimeOpenApprovals = () => {
  const { data, loading, error, refetch } = useQuery(GET_OPEN_APPROVALS_LIST, {
    fetchPolicy: "cache-and-network",
  });

  useSubscription(MY_TIME_REQUESTS_SUBSCRIPTION, {
    fetchPolicy: "network-only",
    onData: () => {
      refetch();
    },
  });

  return {
    data: data?.notApprovedList || [],
    loading,
    error,
    refetch,
  };
};

export default useMyTimeOpenApprovals;
